/* tslint:disable:max-classes-per-file  */

import * as _4 from 'lodash4';

export class CommentMeta {
  _created_ts: moment.Moment;
  _updated_ts: moment.Moment;
  id: number;
}

export interface ICommentSenderInfo {
  email: string;
  first_name: string;
  id: number;
  last_name: string;
  username: string;
}

type CommentType = 'cat.Course' | 'academicplan.Programslot' | null;

export class BaseComment {
  id: number;
  message: string;
  created_ts: string;
  updated_ts: string;
  object_id: number | null; // course_id now
  is_visible: boolean;
  sender: number;
  sender_info: ICommentSenderInfo;
  content_type: CommentType;

  constructor(slot: Partial<BaseComment>) {
    _4.merge(this, {}, slot);
    return this;
  }
}

export class CourseComment extends BaseComment {
  content_type: 'cat.Course';
  object_id: number;
}

export class SlotComment extends BaseComment {
  content_type: 'academicplan.Programslot';
  object_id: number;
}

export class PlanComment extends BaseComment {
  content_type: null;
  object_id: null;
}

export type Comment = CourseComment | SlotComment | PlanComment;

export class CommentBuilder {
  id: number;
  message: string;
  created_ts: string;
  updated_ts: string;
  object_id: number | null;
  is_visible: boolean;
  sender: number;
  sender_info: ICommentSenderInfo;

  content_type: CommentType;

  constructor(slot: Partial<Comment>) {
    _4.merge(this, {}, slot);
    return this;
  }

  static build(slot: CourseComment): CourseComment;
  static build(slot: PlanComment): PlanComment;
  static build(slot: SlotComment): SlotComment;

  static build(slot: Comment): Comment {
    if (slot.content_type === null) {
      return new PlanComment(slot);
    } else if (slot.content_type === 'cat.Course') {
      return new CourseComment(slot);
    } else {
      return new SlotComment(slot);
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/comments/builders/comment_builder.ts